import { WorkflowStateTypes } from './workflow-state-types.model';
import { Role } from 'src/app/model/roles';
import { WorkflowStateTypes1 } from './workflow-state-types1.model';
import { User } from 'src/app/component/auth/model/user.model';

export class Transitions {
    ID?: number;
    WORKFLOW_STATE_TYPES_ID_FROM?: number;
    WORKFLOW_STATE_TYPES_ID_TO?: number;
    ROLES_ID?: number;
    PREREQUISITES_REQUIRED?: boolean;
    ASSIGN_USER?: boolean;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
    TRANSITION_PROPERTIES?: any[];
    TRANSITION_REGIONS?: any[];
    TRANSITION_FIXED_LOGIN_DETAILS?: any[];
    ROLE?: Role;
    WORKFLOW_STATE_TYPES?: WorkflowStateTypes;
    WORKFLOW_STATE_TYPES1?: WorkflowStateTypes1;
}

export class TransitionStorage {
  chosenToState: any;
  assignToUser: any;
  transitions: any[];
  valid: boolean;
  stateValid: any;
  transitionValid: boolean;
  callbackFunction: () => void;
  preFunction: () => void;
  title: string;
  errorMsg: string;
  showErrorMsg: boolean;
  transitionToUserMessage: string;
  messageToTransitionUser: string;
  transitioning: boolean;
  reloadRoute: boolean;
}
